import { Subject, share } from 'rxjs';
import { tag } from 'rxjs-spy/operators';
import { _namespaceAction } from '../namespace';
import { ActionStream, ActionDispatcher } from '../types/helpers';
import { UnknownAction } from './types';

/**
 * Creates an action stream with a dispatcher.
 * Can also be used to create a custom action stream/dispatch pair for tests.
 */
export function createActionStream() {
  const actionSubject$ = new Subject<UnknownAction>();

  const action$: ActionStream = actionSubject$.pipe(tag('action$'), share());

  const dispatchAction: ActionDispatcher = (action, namespace) => {
    if (namespace === undefined) {
      actionSubject$.next(action);
    } else {
      actionSubject$.next(_namespaceAction(namespace, action));
    }
  };

  return {
    /**
     * The main action stream for RxBeach
     */
    action$,
    /**
     * Dispatch an action to the action stream
     *
     * If namespace is provided, it will be set on the action.
     *
     * @param action The action to dispatch to action$
     * @param namespace Optional namespace to add to the action
     */
    dispatchAction,
  };
}
